export const LOGOUT_USER = "LOGOUT_USER";
export const LOGIN_LOADING = 'LOGIN_LOADING';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const CLEAR_AUTH_STATE = 'CLEAR_AUTH_STATE';

export const PATIENT_LOADING = "PATIENT_LOADING";
export const PATIENT_SUCCESS = 'PATIENT_SUCCESS';
export const PATIENT_FAIL = 'PATIENT_FAIL';

export const PATIENT_CREATE_LOADING = "PATIENT_CREATE_LOADING";
export const PATIENT_CREATE_SUCCESS = 'PATIENT_CREATE_SUCCESS';
export const PATIENT_CREATE_FAIL = 'PATIENT_CREATE_FAIL';

export const PATIENT_SEARCH_LOADING = "PATIENT_SEARCH_LOADING";
export const PATIENT_SEARCH_SUCCESS = 'PATIENT_SEARCH_SUCCESS';
export const PATIENT_SEARCH_FAIL = 'PATIENT_SEARCH_FAIL';

export const SERVICE_SEARCH_LOADING = "SERVICE_SEARCH_LOADING";
export const SERVICE_SEARCH_SUCCESS = 'SERVICE_SEARCH_SUCCESS';
export const SERVICE_SEARCH_FAIL = 'SERVICE_SEARCH_FAIL';

export const GET_VISIT_LOADING = "GET_VISIT_LOADING";
export const GET_VISIT_SUCCESS = 'GET_VISIT_SUCCESS';
export const GET_VISIT_FAIL = 'GET_VISIT_FAIL';

export const GET_VISIT_WAITING_LOADING = "GET_VISIT_WAITING_LOADING";
export const GET_VISIT_WAITING_SUCCESS = 'GET_VISIT_WAITING_SUCCESS';
export const GET_VISIT_WAITING_FAIL = 'GET_VISIT_WAITING_FAIL';
export const GET_CLEAR_VISIT_WAITING_FAIL = 'GET_CLEAR_VISIT_WAITING_FAIL';

export const GET_OPENED_VISIT_LOADING = "GET_OPENED_VISIT_LOADING";
export const GET_OPENED_VISIT_SUCCESS = 'GET_OPENED_VISIT_SUCCESS';
export const GET_OPENED_VISIT_FAIL = 'GET_OPENED_VISIT_FAIL';
export const GET_CLEAR_OPENED_VISIT_FAIL = 'GET_CLEAR_OPENED_VISIT_FAIL';

export const CREATE_VISIT_LOADING = "CREATE_VISIT_LOADING";
export const CREATE_VISIT_SUCCESS = 'CREATE_VISIT_SUCCESS';
export const CREATE_VISIT_FAIL = 'CREATE_VISIT_FAIL';

export const GET_FORM_FIELDS_LOADING = "GET_FORM_FIELDS_LOADING";
export const GET_FORM_FIELDS_SUCCESS = 'GET_FORM_FIELDS_SUCCESS';
export const GET_FORM_FIELDS_FAIL = 'GET_FORM_FIELDS_FAIL';

export const POST_ASSESSMENT_FORM_LOADING = "GET_FORM_FIELDS_LOADING";
export const POST_ASSESSMENT_FORM_SUCCESS = 'GET_FORM_FIELDS_SUCCESS';
export const POST_ASSESSMENT_FORM_FAIL = 'GET_FORM_FIELDS_FAIL';

export const GET_ASSESSMENT_FORM_REPORTS_LOADING = "GET_ASSESSMENT_FORM_REPORTS_LOADING";
export const GET_ASSESSMENT_FORM_REPORTS_SUCCESS = 'GET_ASSESSMENT_FORM_REPORTS_SUCCESS';
export const GET_ASSESSMENT_FORM_REPORTS_FAIL = 'GET_ASSESSMENT_FORM_REPORTS_FAIL';

export const POST_COMPANY_ITEM_PREAUTHO_LOADING = "POST_COMPANY_ITEM_PREAUTHO_LOADING";
export const POST_COMPANY_ITEM_PREAUTHO_SUCCESS = 'POST_COMPANY_ITEM_PREAUTHO_SUCCESS';
export const POST_COMPANY_ITEM_PREAUTHO_FAIL = 'POST_COMPANY_ITEM_PREAUTHO_FAIL';

export const GET_MEDIC_ROUTES_LOADING = "GET_MEDIC_ROUTES_LOADING";
export const GET_MEDIC_ROUTES_SUCCESS = 'GET_MEDIC_ROUTES_SUCCESS';
export const GET_MEDIC_ROUTES_FAIL = 'GET_MEDIC_ROUTES_FAIL';

export const GET_MEDICATIONS_LOADING = "GET_MEDICATIONS_LOADING";
export const GET_MEDICATIONS_SUCCESS = 'GET_MEDICATIONS_SUCCESS';
export const GET_MEDICATIONS_FAIL = 'GET_MEDICATIONS_FAIL';
export const GET_CLEAR_MEDICATIONS = 'GET_CLEAR_MEDICATIONS';

export const GET_PATIENT_VISIT_HISTORY_LOADING = "GET_PATIENT_VISIT_HISTORY_LOADING";
export const GET_PATIENT_VISIT_HISTORY_SUCCESS = 'GET_PATIENT_VISIT_HISTORY_SUCCESS';
export const GET_PATIENT_VISIT_HISTORY_FAIL = 'GET_PATIENT_VISIT_HISTORY_FAIL';
export const GET_CLEAR_PATIENT_VISIT_HISTORY = 'GET_CLEAR_PATIENT_VISIT_HISTORY';

export const GET_PATIENT_VISIT_MEDICATIONS_HISTORY_LOADING = "GET_PATIENT_VISIT_MEDICATIONS_HISTORY_LOADING";
export const GET_PATIENT_VISIT_MEDICATIONS_HISTORY_SUCCESS = 'GET_PATIENT_VISIT_MEDICATIONS_HISTORY_SUCCESS';
export const GET_PATIENT_VISIT_MEDICATIONS_HISTORY_FAIL = 'GET_PATIENT_VISIT_MEDICATIONS_HISTORY_FAIL';
export const GET_CLEAR_PATIENT_VISIT_MEDICATIONS_HISTORY = 'GET_CLEAR_PATIENT_VISIT_MEDICATIONS_HISTORY';

export const GET_PATIENT_VISIT_SERVICES_HISTORY_LOADING = "GET_PATIENT_VISIT_SERVICES_HISTORY_LOADING";
export const GET_PATIENT_VISIT_SERVICES_HISTORY_SUCCESS = 'GET_PATIENT_VISIT_SERVICES_HISTORY_SUCCESS';
export const GET_PATIENT_VISIT_SERVICES_HISTORY_FAIL = 'GET_PATIENT_VISIT_SERVICES_HISTORY_FAIL';
export const GET_CLEAR_PATIENT_VISIT_SERVICES_HISTORY = 'GET_CLEAR_PATIENT_VISIT_SERVICES_HISTORY';

export const GET_IPD_WARDS_LOADING = "GET_IPD_WARDS_LOADING";
export const GET_IPD_WARDS_SUCCESS = 'GET_IPD_WARDS_SUCCESS';
export const GET_IPD_WARDS_FAIL = 'GET_IPD_WARDS_FAIL';
export const GET_CLEAR_IPD_WARDS = 'GET_CLEAR_IPD_WARDS';

export const GET_IPD_ADMITTED_PATIENTS_LOADING = "GET_IPD_ADMITTED_PATIENTS_LOADING";
export const GET_IPD_ADMITTED_PATIENTS_SUCCESS = 'GET_IPD_ADMITTED_PATIENTS_SUCCESS';
export const GET_IPD_ADMITTED_PATIENTS_FAIL = 'GET_IPD_ADMITTED_PATIENTS_FAIL';
export const GET_CLEAR_IPD_ADMITTED_PATIENTS = 'GET_CLEAR_IPD_ADMITTED_PATIENTS';

export const TRAVERSING_LOADING = "TRAVERSING_LOADING";
export const TRAVERSING_SUCCESS = 'TRAVERSING_SUCCESS';
export const TRAVERSING_FAIL = 'TRAVERSING_FAIL';

export const TRAVERSING_IN_LOADING = "TRAVERSING_IN_LOADING";
export const TRAVERSING_IN_SUCCESS = 'TRAVERSING_IN_SUCCESS';
export const TRAVERSING_IN_FAIL = 'TRAVERSING_IN_FAIL';

export const GET_MOSTLY_FREQUENTLY_SERVICES_LOADING = "GET_MOSTLY_FREQUENTLY_SERVICES_LOADING";
export const GET_MOSTLY_FREQUENTLY_SERVICES_SUCCESS = 'GET_MOSTLY_FREQUENTLY_SERVICES_SUCCESS';
export const GET_MOSTLY_FREQUENTLY_SERVICES_FAIL = 'GET_MOSTLY_FREQUENTLY_SERVICES_FAIL';
export const CLEAR_GET_MOSTLY_FREQUENTLY_SERVICES = 'CLEAR_GET_MOSTLY_FREQUENTLY_SERVICES';

export const GET_DOCTOR_TIMESLOTS_LOADING = "GET_DOCTOR_TIMESLOTS_LOADING";
export const GET_DOCTOR_TIMESLOTS_SUCCESS = 'GET_DOCTOR_TIMESLOTS_SUCCESS';
export const GET_DOCTOR_TIMESLOTS_FAIL = 'GET_DOCTOR_TIMESLOTS_FAIL';

export const GET_PATIENT_PACKAGE_SERVICES_LOADING = "GET_PATIENT_PACKAGE_SERVICES_LOADING";
export const GET_PATIENT_PACKAGE_SERVICES_SUCCESS = 'GET_PATIENT_PACKAGE_SERVICES_SUCCESS';
export const GET_PATIENT_PACKAGE_SERVICES_FAIL = 'GET_PATIENT_PACKAGE_SERVICES_FAIL';
export const CLEAR_GET_PATIENT_PACKAGE_SERVICES = 'CLEAR_GET_PATIENT_PACKAGE_SERVICES';

export const GET_PATIENT_VISIT_PROGRESS_LOADING = "GET_PATIENT_VISIT_PROGRESS_LOADING";
export const GET_PATIENT_VISIT_PROGRESS_SUCCESS = 'GET_PATIENT_VISIT_PROGRESS_SUCCESS';
export const GET_PATIENT_VISIT_PROGRESS_FAIL = 'GET_PATIENT_VISIT_PROGRESS_FAIL';
export const CLEAR_GET_PATIENT_VISIT_PROGRESS = 'CLEAR_GET_PATIENT_VISIT_PROGRESS';


export const GET_INSPECTION_CHECKLIST_LOADING = "GET_INSPECTION_CHECKLIST_LOADING";
export const GET_INSPECTION_CHECKLIST_SUCCESS = 'GET_INSPECTION_CHECKLIST_SUCCESS';
export const GET_INSPECTION_CHECKLIST_FAIL = 'GET_INSPECTION_CHECKLIST_FAIL';
export const CLEAR_GET_INSPECTION_CHECKLIST = 'CLEAR_GET_INSPECTION_CHECKLIST';

export const POST_INSPECTION_CHECKLIST_LOADING = "POST_INSPECTION_CHECKLIST_LOADING";
export const POST_INSPECTION_CHECKLIST_SUCCESS = 'POST_INSPECTION_CHECKLIST_SUCCESS';
export const POST_INSPECTION_CHECKLIST_FAIL = 'POST_INSPECTION_CHECKLIST_FAIL';
export const CLEAR_POST_INSPECTION_CHECKLIST = 'CLEAR_POST_INSPECTION_CHECKLIST';

export const GET_VEHICLE_STATUS_LOADING = "GET_VEHICLE_STATUS_LOADING";
export const GET_VEHICLE_STATUS_SUCCESS = 'GET_VEHICLE_STATUS_SUCCESS';
export const GET_VEHICLE_STATUS_FAIL = 'GET_VEHICLE_STATUS_FAIL';
export const CLEAR_GET_VEHICLE_STATUS_STATE = 'CLEAR_GET_VEHICLE_STATUS_STATE';

export const GET_PENDING_VEHICLE_INSPECTION_LOADING = "GET_PENDING_VEHICLE_INSPECTION_LOADING";
export const GET_PENDING_VEHICLE_INSPECTION_SUCCESS = 'GET_PENDING_VEHICLE_INSPECTION_SUCCESS';
export const GET_PENDING_VEHICLE_INSPECTION_FAIL = 'GET_PENDING_VEHICLE_INSPECTION_FAIL';
export const CLEAR_GET_PENDING_VEHICLE_INSPECTION_STATE = 'CLEAR_GET_PENDING_VEHICLE_INSPECTION_STATE';

export const POST_VEHICLE_INSPECTION_LOADING = "POST_VEHICLE_INSPECTION_LOADING";
export const POST_VEHICLE_INSPECTION_SUCCESS = 'POST_VEHICLE_INSPECTION_SUCCESS';
export const POST_VEHICLE_INSPECTION_FAIL = 'POST_VEHICLE_INSPECTION_FAIL';
export const CLEAR_POST_VEHICLE_INSPECTION_STATE = 'CLEAR_POST_VEHICLE_INSPECTION_STATE';

export const GET_LICENSE_STATUS_LOADING = "GET_LICENSE_STATUS_LOADING";
export const GET_LICENSE_STATUS_SUCCESS = 'GET_LICENSE_STATUS_SUCCESS';
export const GET_LICENSE_STATUS_FAIL = 'GET_LICENSE_STATUS_FAIL';
export const CLEAR_GET_LICENSE_STATUS_STATE = 'CLEAR_GET_LICENSE_STATUS_STATE';

export const DELETE_CHECKLIST_COMPONENT_LOADING = "DELETE_CHECKLIST_COMPONENT_LOADING";
export const DELETE_CHECKLIST_COMPONENT_SUCCESS = 'DELETE_CHECKLIST_COMPONENT_SUCCESS';
export const DELETE_CHECKLIST_COMPONENT_FAIL = 'DELETE_CHECKLIST_COMPONENT_FAIL';
export const CLEAR_DELETE_CHECKLIST_COMPONENT_STATE = 'CLEAR_DELETE_CHECKLIST_COMPONENT_STATE';

export const EDIT_CHECKLIST_COMPONENT_LOADING = "EDIT_CHECKLIST_COMPONENT_LOADING";
export const EDIT_CHECKLIST_COMPONENT_SUCCESS = 'EDIT_CHECKLIST_COMPONENT_SUCCESS';
export const EDIT_CHECKLIST_COMPONENT_FAIL = 'EDIT_CHECKLIST_COMPONENT_FAIL';
export const CLEAR_EDIT_CHECKLIST_COMPONENT_STATE = 'CLEAR_EDIT_CHECKLIST_COMPONENT_STATE';

export const GET_INVOICES_LOADING = "GET_INVOICES_LOADING";
export const GET_INVOICES_SUCCESS = 'GET_INVOICES_SUCCESS';
export const GET_INVOICES_FAIL = 'GET_INVOICES_FAIL';
export const CLEAR_GET_INVOICES_STATE = 'CLEAR_GET_INVOICES_STATE';

export const POST_INVOICES_LOADING = "POST_INVOICES_LOADING";
export const POST_INVOICES_SUCCESS = 'POST_INVOICES_SUCCESS';
export const POST_INVOICES_FAIL = 'POST_INVOICES_FAIL';
export const CLEAR_POST_INVOICES_STATE = 'CLEAR_POST_INVOICES_STATE';

export const POST_REQUEST_CONTROL_NUMBER_LOADING = "POST_REQUEST_CONTROL_NUMBER_LOADING";
export const POST_REQUEST_CONTROL_NUMBER_SUCCESS = 'POST_REQUEST_CONTROL_NUMBER_SUCCESS';
export const POST_REQUEST_CONTROL_NUMBER_FAIL = 'POST_REQUEST_CONTROL_NUMBER_FAIL';
export const CLEAR_POST_REQUEST_CONTROL_NUMBER_STATE = 'CLEAR_POST_REQUEST_CONTROL_NUMBER_STATE';

export const GET_VEHICLE_ROUTES_LOADING = "GET_VEHICLE_ROUTES_LOADING";
export const GET_VEHICLE_ROUTES_SUCCESS = 'GET_VEHICLE_ROUTES_SUCCESS';
export const GET_VEHICLE_ROUTES_FAIL = 'GET_VEHICLE_ROUTES_FAIL';
export const CLEAR_GET_VEHICLE_ROUTES_STATE = 'CLEAR_GET_VEHICLE_ROUTES_STATE';

export const GET_VEHICLE_ROUTE_INSPECTION_LOADING = "GET_VEHICLE_ROUTE_INSPECTION_LOADING";
export const GET_VEHICLE_ROUTE_INSPECTION_SUCCESS = 'GET_VEHICLE_ROUTE_INSPECTION_SUCCESS';
export const GET_VEHICLE_ROUTE_INSPECTION_FAIL = 'GET_VEHICLE_ROUTE_INSPECTION_FAIL';
export const CLEAR_VEHICLE_ROUTE_INSPECTION_STATE = 'CLEAR_VEHICLE_ROUTE_INSPECTION_STATE';
